import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
    providers: {}
}

export const getters = {}

export const mutations = {
    PROVIDERS(state, request) {
        state.providers = request
    },
}

export const actions = {
    
    init({ state, dispatch }) {},
    
    fetchProviders(context, query){
        query = query || ''
        return axios.get(`${serverUrl}/api/providers/${query}`).then((response) => {
            const request = response.data
            context.commit('PROVIDERS', request)
            return request
        })
    },
    
    createUpdateProvider(context, formData) {
        let promise = null
        if (formData.url){
            promise =  axios.put(formData.url, formData)
        }else {
            promise =  axios.post(`${serverUrl}/api/providers/`, formData)
        }
        return promise.then(
            (response) => {
                return response.data
            }
        )
    }
}